import { MCustomerPage } from './mCustomer.page';

export default MCustomerPage;
